document.addEventListener('DOMContentLoaded',()=>{
  const dialog=document.querySelector('[data-restock-dialog]');if(!dialog)return;
  const form=dialog.querySelector('form'),status=dialog.querySelector('[data-restock-status]');let selected,opener,generation=0;
  function open(target){
    if(dialog.open||!target.dataset.restockId)return;
    generation++;selected=target.dataset.restockId;opener=target;form.reset();form.hidden=false;status.textContent='';form.querySelector('button[type="submit"]').disabled=false;
    dialog.querySelector('[data-restock-name]').textContent=target.dataset.restockTitle;
    dialog.querySelector('[data-restock-product-link]').href=target.href||`${location.pathname}?variant=${selected}`;
    dialog.showModal();
  }
  dialog.querySelector('[data-restock-close]').onclick=()=>dialog.close();
  dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
  dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}});
  // Delegation includes cards inserted by the asynchronous search renderer.
  document.addEventListener('click',event=>{
    const target=event.target.closest('[data-restock-id]');
    if(target&&!target.hidden){event.preventDefault();open(target);}
  });
  // Intentional desktop hover opens the same email prompt; touch uses a tap.
  let hoverTimer;
  document.addEventListener('pointerover',event=>{
    if(!matchMedia('(hover: hover) and (pointer: fine)').matches||dialog.open)return;
    const target=event.target.closest('.product-card [data-restock-id]');
    if(!target||target.contains(event.relatedTarget))return;
    clearTimeout(hoverTimer);
    hoverTimer=setTimeout(()=>{if(target.matches(':hover'))open(target);},650);
  });
  document.addEventListener('pointerout',event=>{
    const target=event.target.closest('.product-card [data-restock-id]');
    if(target&&!target.contains(event.relatedTarget))clearTimeout(hoverTimer);
  });
  document.querySelectorAll('[data-product-root]').forEach(root=>{
    const button=root.querySelector('[data-restock-product]');if(!button)return;
    root.addEventListener('change',()=>{
      const control=root.querySelector('[data-variant-input]:checked')||root.querySelector('[data-variant-select]')?.selectedOptions[0];
      if(!control)return;
      button.hidden=control.dataset.available!=='false';button.dataset.restockId=control.value;
      const label=root.querySelector(`label[for="${control.id}"] strong`);
      button.dataset.restockTitle=root.querySelector('h1').textContent+' — '+(label?.textContent||control.textContent);
    });
  });
  form.addEventListener('submit',async event=>{
    event.preventDefault();const currentGeneration=generation,button=form.querySelector('button[type="submit"]');button.disabled=true;status.textContent='Saving your alert…';
    try{
      const endpoint=new URL(dialog.dataset.endpoint);if(endpoint.protocol!=='https:')throw Error('Stock alerts are not configured yet. Contact care@velissefabrics.com.');
      const response=await fetch(endpoint,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({variantId:selected,email:form.elements.email.value,consent:form.elements.consent.checked,website:form.elements.website.value})});
      const data=await response.json();if(!response.ok)throw Error(data.error||'Please try again later.');
      if(currentGeneration===generation){status.textContent=data.message;form.hidden=true;}
    }catch(error){if(currentGeneration===generation)status.textContent=error.message==='Failed to fetch'?'Unable to save your alert. Please try again or contact care@velissefabrics.com.':error.message;}
    finally{if(currentGeneration===generation)button.disabled=false;}
  });
});
